// @flow
import * as React from "react"
import {FormattedMessage, injectIntl} from "react-intl"

export const Tooltip = injectIntl((props: {required?: boolean} & *) => {
  const {intl, id, required = false, children} = props
  return !!intl.messages[id] || required ? (
    <span title={intl.formatMessage({id})}>{children}</span>
  ) : (
    children
  )
})

export const Description = injectIntl(({intl, id}) => {
  id += ".description"
  return (
    <Tooltip id={id + ".lol"}>
      <FormattedMessage id={id} />
    </Tooltip>
  )
  //return !!intl.messages[id]
  //  ? <Tooltip id={id + ".lol"}><FormattedMessage id={id} /></Tooltip>
  //  : null
})
export const prefixedDescription = (prefix: string) => (props: {
  id: string,
}) => <Description {...props} id={`${prefix}.${props.id}`} />



// WEBPACK FOOTER //
// ./src/common/Tooltip.js